import React, { useEffect, useState } from 'react';
import { Global } from "@emotion/react";
import { styled } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { grey } from "@mui/material/colors";
import { Grid } from '@mui/material';
import Typography from "@mui/material/Typography";
import SwipeableDrawer from "@mui/material/SwipeableDrawer";
import useScreenSize from '../../../ts/useScreenSize';
import ScanHistoryMobile from './ScanHistoryMobile';
import { BrowserView, MobileView } from 'react-device-detect';
import { useTranslation } from 'react-i18next';

const Root = styled("div")(({ theme }) => ({
    height: "100%",
    backgroundColor:
        theme.palette.mode === "light"
            ? grey[100]
            : theme.palette.background.default,
}));

const StyledBox = styled("div")(({ theme }) => ({
    backgroundColor: theme.palette.mode === "light" ? "#fff" : grey[800],
}));

const Puller = styled("div")(({ theme }) => ({
    width: 30,
    height: 6,
    backgroundColor: theme.palette.mode === "light" ? grey[300] : grey[900],
    borderRadius: 3,
    position: "absolute",
    top: 8,
    left: "calc(50% - 15px)",
    
}));

function SwipeableEdgeDrawer(props: any) {
    const { window } = props;
    const { cargoResponses, selectedScanIndex, setSelectedScanIndex, setOpenScanDetails, machine, machineEvents, drawerOpen, setDrawerOpen,
        onEndReached, onStartReached, onAtTopChange, loadingOlder, refreshEnabled } = props
    const [mountDrawer, setMountDrawer] = useState(false);
    const [drawerBleeding, setDrawerBleeding] = useState(150);
    const { t } = useTranslation();

    const screenSize = useScreenSize();

    const drawerBreak = 600;

    useEffect(() => {
        if (screenSize.width < drawerBreak) {
            setMountDrawer(true)
        } else if (screenSize.width >= drawerBreak) {
            setMountDrawer(false)
        }
    }, [screenSize])

    // For Mobile - shrinks the drawer height when height is less than 450px
    useEffect(() => {
        // Check if mobile size and height is less than 450px
        if (screenSize.width < 600 && screenSize.height < 450) {
            setDrawerBleeding(35);
        } else {
            setDrawerBleeding(150);
        }
    }, [screenSize.width, screenSize.height]);

    const toggleDrawer = (newOpen: boolean) => () => {
        setDrawerOpen(newOpen);
    };

    // This is used only for the example
    const container =
        window !== undefined ? () => window().document.body : undefined;

    return (
        <Root>
            <CssBaseline />
            <Global
                styles={{
                    ".MuiDrawer-root > .MuiPaper-root": {
                        height: `calc(80% - ${drawerBleeding}px)`,
                        overflow: "visible",
                    },
                }}
            />
            <SwipeableDrawer
                className="SWIPEABLE_DRAWER"    
                container={container}
                anchor="bottom"
                open={drawerOpen}
                onClose={toggleDrawer(false)}
                onOpen={toggleDrawer(true)}
                swipeAreaWidth={drawerBleeding}
                disableSwipeToOpen={false}
                ModalProps={{
                    keepMounted: mountDrawer,
                }}
                onMouseDown={() => setDrawerOpen(true)}
            >
                <BrowserView>
                    <StyledBox
                        sx={{
                            position: 'absolute',
                            top: -drawerBleeding,
                            borderTopLeftRadius: 8,
                            borderTopRightRadius: 8,
                            visibility: 'visible',
                            right: 0,
                            left: 0,
                            bottom: '0',
                            pointerEvents: "all",
                            boxShadow: 3
                        }}
                    >
                        <Puller  />
                        <Grid
                            container
                            direction="row"
                            justifyContent="space-between"
                            alignItems="center"
                        >
                            <Typography sx={{ p: 1, pb: 1.5, color: 'var(--spectre-text-muted)' }}>{t('control.eventHistory.title')}</Typography>
                        </Grid>
                        <Grid sx={{ overflow: 'auto', height: '100%' }}>
                            <ScanHistoryMobile cargoResponses={cargoResponses} selectedScanIndex={selectedScanIndex} setSelectedScanIndex={setSelectedScanIndex} setOpenScanDetails={setOpenScanDetails} machine={machine} machineEvents={machineEvents} open={drawerOpen} onEndReached={onEndReached} onStartReached={onStartReached} onAtTopChange={onAtTopChange} loadingOlder={loadingOlder} refreshEnabled={refreshEnabled} listHeight="100%"></ScanHistoryMobile>
                        </Grid>
                    </StyledBox>
                </BrowserView>
                <MobileView>
                    <StyledBox
                        sx={{
                            position: 'absolute',
                            top: -drawerBleeding,
                            borderTopLeftRadius: 8,
                            borderTopRightRadius: 8,
                            visibility: 'visible',
                            right: 0,
                            left: 0,
                            bottom: '0',
                            
                        }}
                    >
                        <Puller /> 
                        <Grid
                            container
                            direction="row"
                            justifyContent="space-between"
                            alignItems="center"
                        >
                            <Typography sx={{ p: 1, pb: 1.5, color: 'var(--spectre-text-primary)' }}>{t('control.eventHistory.title')}</Typography>
                        </Grid>
                        <Grid sx={{ overflow: 'auto', height: '100%' }}>
                            <ScanHistoryMobile cargoResponses={cargoResponses} selectedScanIndex={selectedScanIndex} setSelectedScanIndex={setSelectedScanIndex} setOpenScanDetails={setOpenScanDetails} machine={machine} machineEvents={machineEvents} open={false} onEndReached={onEndReached} onStartReached={onStartReached} onAtTopChange={onAtTopChange} loadingOlder={loadingOlder} refreshEnabled={refreshEnabled} listHeight="100%"/>
                        </Grid>
                    </StyledBox>
                </MobileView>
            </SwipeableDrawer>
        </Root>
    );
}

export default React.memo(SwipeableEdgeDrawer);